import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PdsMessageService } from '../../Services/pds-message.service';

@Component({
  selector: 'app-print-button',
  templateUrl: './print-button.component.html',
  styleUrls: ['./print-button.component.css'],
  imports: [ButtonModule, BlockUIModule, DialogModule, CommonModule, ProgressSpinnerModule],
  standalone: true
})
export class PrintButtonComponent {

  @Input()
  blocked: boolean = false;

  private _dialogVisible: boolean = false;

  @Input()
  set dialogVisible(value: boolean) {
    this._dialogVisible = value;
    this.blocked = false;
  }
  get dialogVisible(): boolean {
    return this._dialogVisible;
  }

  @Output()
  buttonClicked: EventEmitter<any> = new EventEmitter();

  @Output()
  closed: EventEmitter<any> = new EventEmitter();

  @Output()
  cleared: EventEmitter<any> = new EventEmitter();

  constructor(private pdsMessageService: PdsMessageService) { }

  /**
   * Handler tlačítka
   */
  onClick() {
    this.buttonClicked.emit();
  }

  onClose() {
    this.pdsMessageService.clearAll();
    this.dialogVisible = false;
    this.closed.emit();
  }

  onClear() {
    this.pdsMessageService.clearAll();
    this.dialogVisible = false;
    this.cleared.emit();
  }
}
